import CRMAuthRoutes from '../../../../vendor/z5internet/crm-ui/src/resources/assets/js/Routes/authRoutes';

import OAuthRoutes from '../../../../vendor/z5internet/ruf_oauth/src/resources/assets/js/src/app/Auth/Routes';

export default [].concat(CRMAuthRoutes).concat(OAuthRoutes);
